/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;font-size:84%}.invalid-message[_ngcontent-%COMP%]{display:block;color:#f44336;margin:-6px 0 10px 100px}"];
export { styles as styles };
